import React, { Component } from 'react';
import { PDFExport } from '@progress/kendo-react-pdf';
import { Col, Container, Row } from 'reactstrap';
import Skills from './components/Skills';
import Section from "./components/Section";
import Intro from './components/Intro';
import * as Constants from '../../Constants/Constants';
import { resume_download_link } from '../../Constants/Constants';
// import { data } from '../../store/data';
import QRCode from 'qrcode.react';
import { toRGBA } from './Helpers';
import { SUBTITLE_LINK_INLINE } from '../../Constants/Constants';

class Paper extends Component {
	// #311B92
	constructor(props) {
		super(props);
		this.state = {
			data: props.data,
			// window_width: 0,
			// window_height: 0
		};
		let accentColor = "#1976d2"; //"#7E57C2"; // "#039be5";
		let introBackgroundColor = toRGBA(accentColor, 0.1); //'rgba(126, 87, 194, 0.1)'; //"#e3f2fd";

		this.styles = {
			container: {
				align: "center",
				width: "100%",
				fontSize: "1.5rem !important",
				lineHeight: '1.5rem',
				color: '#444',
				fontFamily: '"Merriweather", "Lucida Sans", "Candara"',
				// border: "5px double #555",
			},
			paper: {
				padding: "10px 10px",
				//			margin: "10px 10px",
				//minHeight: "100vh",
				// border: "5px double #555",
				// borderRadius: "5px",
				// color: accentColor,
				backgroundColor: "#fff",
			},
			title: {
				fontWeight: 'bold',
			},
			designation: {
				fontWeight: 400,
				fontStyle: 'italic'
			},
			keyValue: {
				padding: "0",
				margin: "0"
			},
			sidebar: {
				paddingRight: "1rem !important",
			},
			'rightSidebar': {
			},
			sidebarLink: {
				color: accentColor,
			},
			link: {
				color: accentColor,
			},
			social_links: {
				color: "#000"
			},
			socialLinksContainer: {
				backgroundImage: "linear-gradient(to right, #ddd, #ccc)",
				padding: "20px 10px"
			},

			section: {
				title: {
					color: "#444",
					fontWeight: 600
				},
				color: '#444',
				fontWeight: 500,
				// padding: "15px 10px",
				padding: "0.5rem 0rem 0.5rem 1rem", //"5px 10px",
				item: {
					paddingBottom: "1rem",
					// fontSize: "1rem",
					// lineHeight: "1.5rem",
					fontWeight: 400,
					// title: { fontWeight: 600, lineHeight: "1.5rem", color: "#b71c1c" },
					title: {
						fontSize: '1rem',
						fontWeight: 'bold',
						lineHeight: "1.5rem",
						color: accentColor,
						marginTop: '0.15rem',
					},
					subTitle: { 
						fontWeight: 500, 
						fontStyle: "italic", 
						color: '#444',
						marginBottom: '0.15rem',
					},
					description: { 
						color: '#444', 
						// textAlign: 'justify', 
					},
					duration: { fontWeight: 500, color: '#555', paddingLeft: '0.5rem' },
				},
				timelineLight: {
					color: 'rgba(255, 255, 255, 1)',
					topBallColor: 'white',
					bottomBallColor: 'white',
					topBallBorderColor: 'white',
				},
				timelineDark: {
					color: '#bdbdbd', //'#bdbdbd', //'rgba(0, 0, 0, 0.4)',
					// topBallColor: '#ffcdd2',
					topBallColor: accentColor,
					// topBallBorderColor: '#b71c1c',
					topBallBorderColor: accentColor,
					bottomBallColor: '#9e9e9e'//'#bdbdbd'
				},
				intro: {
					padding: '1rem 2rem 1rem 1rem',
					margin: '1rem 0rem',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					backgroundColor: introBackgroundColor,
					borderBottom: `2px solid ${accentColor}`
					// borderBottom: '2px solid #b71c1c'
				}
			}
		};
	}

	exportPDF = () => {
		this.resume.save();
	}

	componentDidMount() {
		if(this.resumeComponent) {
			console.log(this.resumeComponent.clientWidth);
		}
		if(this.resume) {
			console.log(this.resume);
		}
	}

	render() {
		// 1024 
		// if (this.props.window_width < 786) {
		// 	return (
		// 		<div>
		// 			<div style={{ minHeight: "100vh" }}
		// 				className="d-flex flex-column justify-content-center align-items-stretch text-center">
		// 				<p>This Section is visible only on Large Screens.</p>
		// 				<div>Click <a href={resume_download_link}>Here</a> to Download</div>
		// 			</div>
		// 		</div>
		// 	);
		// }

		const data = this.state.data;
		let kvs = data.kvs;
		let skills = data.skills;
		let education = data.education;
		let internships = data.internships;
		let projects = data.projects;
		let courses = data.courses;
		// Add this method to the React 
		

		return (
			<>
			{/* // Add this to the render method */}
			{/* <button onClick={this.exportPDF}>download</button> */}
			
			{/* <PDFExport
				scale={(612/(this.resumeComponent && this.resumeComponent.clientWidth || 612))-0.05}
				paperSize='A4'
				fileName="lalit-resume.pdf"
				title=""
				subject=""
				keywords=""
				ref={(r) => this.resume = r}>
				<div 
					ref={(r) => this.resumeComponent = r}
					style={{
						// height: 792*2,
						width: 1200,
						padding: 'none',
						backgroundColor: 'white',
						// border: '1px solid #aaa',
						margin: 'auto',
						// overflowX: 'hidden',
						// overflowY: 'hidden'
					}}
					>
					<div style={{ position: 'relative' }}> */}
						<Container fluid>
							<div style={this.styles.container}>
								<div style={this.styles.paper}>
									{/* <Row>
                    <Col>
                      <div style={{position: 'absolute', right: "20px", zIndex: "1000", backgroundColor: "#fff"}}>
                        <div className="d-flex flex-column justify-content-between align-items-center"
                            style={{padding: "2px 2px", margin: "10px"}}>
                          <QRCode size={100} value='https://lalitjain98.github.io/my-resume/mini'
                                  style={{padding: "2px 2px", backgroundColor: 'white'}}/>
                          <p className="my-1 text-center">View CV Online</p>
                        </div>
                      </div>
                      <Intro
                        title={data.title}
                        subtitle={data.subtitle}
                        styles={this.styles}
                        data={kvs}
                        printSocialAnchors
                        social={data.social}
                      />
                    </Col>
                  </Row> */}
									{/* style={{ marginTop: "1rem" }} */}
									<Row >
										<Col xs={12} style={this.styles.rightSidebar}>
											<Intro
												title={data.title}
												subtitle={data.subtitle}
												styles={this.styles}
												data={kvs}
											// printSocialAnchors
												// social={data.social}
											/>
										</Col>
									</Row>
									<Row style={{ padding: "0rem 1rem" }}>
										<Col className="p-0 pr-3" xs={7} style={this.styles.sidebar}>
											<Section
												showTimeline
												styles={this.styles}
												// icon="fa fa-suitcase"
												title="Experience"
												// data={internships}
												data={internships.filter(item => item.isImportant)}
												datePosition={Constants.DATE_IN_ROW}
												dateFormat={Constants.START_TO_END}
												showDescription={true}
												linkStyles={this.styles.link}
												linkPosition={SUBTITLE_LINK_INLINE}
												linkAlign={'left'}
												isSubtitleLink={true}
											/>
											<Section
												showTimeline
												styles={this.styles}
												// icon="fa fa-graduation-cap"
												title="Education"
												data={education}
												datePosition={Constants.DATE_IN_ROW}
												dateFormat={Constants.END_DATE}
												showDescription={true}
												linkStyles={this.styles.link} 
											/>
										</Col>
										<Col className="p-0 pl-4" xs={5} style={this.styles.rightSidebar}>
											<Section
												styles={this.styles}
												// icon="fa fa-file-code"
												title="Projects"
												data={projects.filter(item => item.isImportant)}
												// .map(item => ({...item, description: Array.isArray(item.description) ? [item.description.join(' ')]: []}))
												datePosition={Constants.DATE_INLINE}
												dateFormat={Constants.END_DATE}
												showDescription={true}
												linkStyles={this.styles.link} 
												linkPosition={SUBTITLE_LINK_INLINE}
											/>
											<Section
												// showTimeline
												styles={this.styles}
												// icon="fa fa-laptop-code"
												title="Trainings"
												data={courses}
												datePosition={Constants.DATE_INLINE}
												dateFormat={Constants.END_DATE}
												showDescription={false}
												linkStyles={this.styles.sidebarLink} 
												linkPosition={SUBTITLE_LINK_INLINE}
											/>
											<Skills
												styles={this.styles}
												commaSeparated
												// icon="fa fa-code"
												data={skills}
											/>
										</Col>

									</Row>
									{/* <Row>
							<Col>
							<Section
								styles={{...this.styles, section: {...this.styles.section, timelineDark: {}, timelineLight: {}}}}
								// icon="fa fa-laptop-code"
								title="Courses and Certificates"
								data={courses}
								datePosition={Constants.DATE_INLINE}
								dateFormat={Constants.END_DATE}
								showDescription={false}
								linkStyles={this.styles.sidebarLink} />
							</Col>
						</Row> */}
									{/* <Row>
						<Col>
						<Skills
						styles={this.styles}
						commaSeparated
						// icon="fa fa-code"
						data={skills}
						/>
						</Col>
						</Row> */}
								</div>
							</div>
						</Container>
						{/* <div className="page-footer">
					Resume Crafted using ReactJS
				</div> */}
					{/* </div> */}
			{/* // 	</div> */}
			{/* // </PDFExport> */}

			</>
		);
	}
}

export default Paper;